import styled from 'styled-components'

export const MapKey = ({
  entries,
  lang = 'de',
}: {
  entries: MapKeyEntry[]
  lang?: 'de' | 'fr'
}) => {
  return (
    <MapKeyRoot>
      {entries.map((entry, index) => {
        const label = entry[`label_${lang}`]
        const color = entry.color
        const rndId = Math.random().toString(36).substring(7)
        return (
          <Entry key={index}>
            {!color.includes('hatched') && <Swatch color={color} />}
            {color.includes('hatched') && (
              <svg width={12} height={12}>
                <pattern
                  id={'diagonalHatch' + rndId}
                  patternUnits='userSpaceOnUse'
                  width='4'
                  height='4'
                >
                  <path
                    d='M-1,1 l2,-2
                     M0,4 l4,-4
                     M3,5 l2,-2'
                    style={{ stroke: color.split('_')[0], strokeWidth: '1' }}
                  />
                </pattern>
                <rect
                  x='0'
                  y='0'
                  width='100%'
                  height='100%'
                  fill={'url(#diagonalHatch' + rndId + ')'}
                />
              </svg>
            )}
            <Label>{label}</Label>
          </Entry>
        )
      })}
    </MapKeyRoot>
  )
}

const MapKeyRoot = styled.div`
  position: fixed;
  left: 100px;
  top: 60px;
  z-index: 100;
  background-color: var(--site-background);
  font-family: var(--font-plex);
  font-size: 12px;

  padding: 10px 15px 10px 15px;
  max-width: 350px;

  display: flex;
  flex-wrap: wrap;

  flex-direction: row;
  @media screen and (max-width: 711px) {
    top: unset;
    left: 30px;
    bottom: 100px;
    max-height: 80px;
    /* max-width: unset; */
  }
`

const Entry = styled.div`
  flex: 0 0 calc(100%);
  display: flex;
  align-items: center;
  line-height: 1.6em;
  text-align: left;
  gap: 10px;
`
const Swatch = styled.div<{ color: string }>`
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: ${(props) => props.color};
  flex: 0 0 12px;
`
const SwatchHatched = styled.div<{ color: string }>`
  display: inline-block;
  width: 12px;
  height: 12px;
  background-image: linear-gradient(
    45deg,
    #000 5%,
    transparent 10%,
    transparent 15%,
    #000 20%,
    #000 25%,
    transparent 30%,
    #fff
  );
  background-size: 50px 50px;
  flex: 0 0 12px;
`
const Label = styled.div`
  flex: 0 0 calc(100% - 30px);
  white-space: nowrap;
`
